import React from 'react'

import Button from 'app/app/(client)/components/atoms/Button/Button'
import Text from 'app/app/(client)/components/atoms/Text/Text'
import { T_NavLink } from 'types/types'

type NavLinkListProps = {
  id: string
  className?: string
  menuOpen: boolean
  navlinks: T_NavLink[]
  handleClick?: (link: string) => void
}

const NavlinkList: React.FC<NavLinkListProps> = ({
  menuOpen = false,
  navlinks,
  className,
  handleClick = () => null
}) => (
  <nav className={`${className} ${menuOpen ? 'flex' : 'hidden'}`}>
    {navlinks.map(navlink => (
      <Button
        id={navlink.key.toLowerCase().replace(/\s+/g, '-') + '-button'}
        key={navlink.key}
        className={`nav-links__button ${navlink.active ? 'nav-links__button--active' : 'cursor-pointer'}`}
        onClick={() => handleClick(navlink.link)}
        disabled={navlink.disabled}
      >
        <Text
          id={`${navlink.key.toLowerCase().replace(/\s+/g, '-')}-label`}
          className={navlink.active ? 'text-primary' : ''}
        >
          {navlink.name}
        </Text>
      </Button>
    ))}
  </nav>
)

export default NavlinkList
